export enum SelectionType {
    Unknown,
    Single,
    Empty,
    Multi,
    NotSupported,
}
